/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CorrectDeliveryStatusDto } from '../../models/correct-delivery-status-dto';
import { DeliveryItem } from '../../models/delivery-item';

export interface DeliveryControllerCorrectDeliveryStatus$Params {
  id: number;
      body: CorrectDeliveryStatusDto
}

export function deliveryControllerCorrectDeliveryStatus(http: HttpClient, rootUrl: string, params: DeliveryControllerCorrectDeliveryStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerCorrectDeliveryStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeliveryItem;
      }>;
    })
  );
}

deliveryControllerCorrectDeliveryStatus.PATH = '/delivery/correct-delivery-status/{id}';
